import initialState from "../initial-state";
import {
  MOSTRAR_CRITERIOS,
  MOSTRAR_CRITERIO,
  LOADING_CRITERIO,
} from "../types";

const { criterios } = initialState;

export const CriterioEvaluacionReducer = (state = criterios, action) => {
  switch (action.type) {
    case LOADING_CRITERIO:
      return {
        ...state,
        isLoading: true,
      };
    case MOSTRAR_CRITERIO:
      return {
        ...state,
        criterio: action.payload,
        isLoading: false,
      };
    case MOSTRAR_CRITERIOS:
      return {
        ...state,
        criterios: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};
